import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=02df35e4"
import script from "./UserNotifications.vue?vue&type=script&lang=js"
export * from "./UserNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports